import React, {Component} from 'react';
import {Card, Grid} from '@material-ui/core';
import {KeyboardArrowRight} from '@material-ui/icons';
import Anchor from 'Components/common/Anchor';

class ProductManagementSCCard extends Component {
    isDisplaySCAddress = (scDetails) => {
        let isFlag = true;
        if (
            typeof scDetails.redCnt !== 'undefined' &&
            typeof scDetails.yellowCnt !== 'undefined'
        ) {
            isFlag = false;
        }
        return isFlag;
    };

    render() {
        const {scDetails} = this.props;

        return (
            <Card
                className="replenishment-sc-card"
                testid="sc-hold-products-sc-card"
                data-sc-name={scDetails.name}
                data-sc-id={scDetails.id}
                onClick={this.props.chooseSC.bind(this, scDetails)}>
                <Grid className="replenishment-content" container spacing={0}>
                    <Grid className="left-content-grid" item xs={11}>
                        <Grid
                            className="sc-details"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid className="sc-name" item xs={11}>
                                <span testid="sc-hold-products-sc-name">
                                    {scDetails.name}
                                    {!this.isDisplaySCAddress(scDetails) ? (
                                        <div>
                                            {scDetails.redCnt > 0 ? (
                                                <div
                                                    className={
                                                        scDetails.redCnt >= 10
                                                            ? 'red-quantity more-quantity'
                                                            : 'red-quantity'
                                                    }>
                                                    {scDetails.redCnt}
                                                </div>
                                            ) : null}
                                            {scDetails.yellowCnt > 0 ? (
                                                <div
                                                    className={
                                                        scDetails.yellowCnt >=
                                                        10
                                                            ? 'yellow-quantity more-quantity'
                                                            : 'yellow-quantity'
                                                    }>
                                                    {scDetails.yellowCnt}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </span>
                            </Grid>
                            {this.isDisplaySCAddress(scDetails) ? (
                                <Grid className="sc-address" item xs={11}>
                                    <span>{scDetails.address}</span>
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                    <Grid className="right-content-grid" item xs={1}>
                        <Anchor>
                            <KeyboardArrowRight />
                        </Anchor>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

export default ProductManagementSCCard;
